export default __webpack_public_path__ + "static/media/_IMG7167.070e130f.jpg";